import * as avgCheckReport from "./avgCheckReport";
import * as gcb2 from "./chisai/GCB2";
import * as clientForm from "./clientForm";
import * as arnicaV2 from "./connectors/arnicaV2";
import * as pbxOnline from "./connectors/pbxOnline";
import * as telephonyBeeline from "./connectors/telephonyBeeline";
import * as telephonyMango from "./connectors/telephonyMango";
import * as telephonyMegaphone from "./connectors/telephonyMegaphone";
import * as whatsapp from "./connectors/whatsapp";
import * as yClients from "./connectors/yClients";
import * as file from "./file";
import * as knowledgeBase from "./knowledgeBase";
import * as marketplace from "./marketplace";
import * as massender from "./massender";
import * as networkFixer from "./networkFixer";
import * as deauthNotification from "./deauthNotification";
import { createInstanceTg, inputCodeTg, sendCodeTg, unAuthInstance } from "./networkFixer";
import * as project from "./projects";
import * as pyrus from "./pyrus";
import * as scheduledReport from "./scheduledReport";
import { messenger } from "./messenger";

const api = {
    gcb2,
    messenger,
    project,
    networkFixer,
    clientForm,
    scheduledReport,
    avgCheckReport,
    connectors: { yClients, arnicaV2, telephonyBeeline, telephonyMango, telephonyMegaphone, whatsapp, telephonyPbx: pbxOnline },
    pyrus,
    marketplace,
    file,
    massender,
    deauthNotification,
    knowledgeBase,
    unAuthInstance,
    createInstanceTg,
    sendCodeTg,
    inputCodeTg,
};
export default api;
